import { useState, useCallback, useEffect } from "react";
import { useSelector } from "react-redux";
import useStyles from "./style";
import { Offcanvas, Dropdown } from "react-bootstrap";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import { profiledetails } from "../../Redux/ProfileSettings/actions";
import { showLoader, hideLoader } from "../../Redux/Loader/actions";
import _ from "lodash";
import settingsApi from "Services/Settings";

const HotelLayout = ({ children }) => {
const classes = useStyles();
const navigate = useNavigate();
const dispatch = useDispatch();
const [showSidebar, setShowSidebar] = useState(false);
  const [profileDetails, setProfileDetails] = useState([]);

// get site logo
const siteNewL = useSelector(
    (state) => state?.SiteSettingsReducer?.siteNewLogo
  );

// get profile details 

    // Get Admin profile details
    const getAdminProfileDetails = useCallback(() => {
      const onSuccess = (res) => {
        if (res?.data?.status === true) {
          setProfileDetails(res?.data?.data);
         // console.log('res?.data?.data-->',res?.data?.data);
          dispatch(profiledetails(res?.data?.data.image));
        } else {
          setProfileDetails([]);
        }
      };
      const onFailure = (err) => {
        //console.log("get admin profile details api", err);
      };
      settingsApi.getProfileDetails({}).then(onSuccess, onFailure);
    }, []);

    useEffect(() => {
        getAdminProfileDetails();
      }, [getAdminProfileDetails]);

// handle logout

  const handleLogout = () => {
  dispatch(showLoader("Loging out..."));
  localStorage.clear();
  navigate(0);
  dispatch(hideLoader());
  };  


  return (
    <div className="d-flex flex-column vh-100" >
      {/* Header */}
      <nav className="sticky-top navbar navbar-light bg-white shadow-sm px-3 d-flex justify-content-between align-items-center">
        
        {/* Hamburger */}
        <button 
          className="btn btn-outline-dark"
          onClick={() => setShowSidebar(true)}
        >
          ☰
        </button>

        {/* Center Logo */}
        <div className="navbar-brand mx-auto">
          <img src={siteNewL} alt="Logo" height="80" width="80" />
        </div>

        {/* Profile Dropdown */}
        <Dropdown align="end">

         <Dropdown.Toggle 
  variant="light" 
  id="dropdown-basic"
  className="d-flex align-items-center gap-2"
>

  <img 
    src={
      !_.isEmpty(profileDetails?.image)
        ? `${profileDetails?.image}`
        : "/assets/images/user/avatar.png"
    } 
    alt="User Avatar" 
    height="50" 
    width="50" 
    className="rounded-circle"
  />

</Dropdown.Toggle>

          <Dropdown.Menu>
            <Dropdown.Item onClick={() => {
                navigate("/profilesettings_hotel");
              }}>Profile</Dropdown.Item>
            <Dropdown.Item  onClick={() => {
                            handleLogout();
                          }} >Logout</Dropdown.Item>
          </Dropdown.Menu>
        </Dropdown>
      </nav>

      {/* Sidebar */}
      <Offcanvas show={showSidebar} onHide={() => setShowSidebar(false)}>
        <Offcanvas.Header closeButton>
          <Offcanvas.Title>Menu</Offcanvas.Title>
        </Offcanvas.Header>
        <Offcanvas.Body>
          <ul className={`list-unstyled ${classes.sidemenus}`}>
            <li className="nav-link" onClick={() => {
                setShowSidebar(false);
                navigate("/dashboard_hotel");
              }} >Dashboard</li>
            <li className="nav-link" onClick={() => {
              setShowSidebar(false)
                navigate("/mytrips_hotel");
              }}>My Trips</li>
            <li  className="nav-link" onClick={() => {
              setShowSidebar(false)
                navigate("/upcomingtrips_hotel");
              }}>Upcoming Trips</li>
            <li className="nav-link"  onClick={() => {
              setShowSidebar(false)
                            handleLogout();
                          }} >Logout</li>
          </ul>
        </Offcanvas.Body>
      </Offcanvas>

      {/* Page Content */}
      <main className="flex-grow-1 p-3 bg-light" style={{ overflowY: "auto" }}>
        {children}
      </main>
    </div>
  );
};

export default HotelLayout;
